type IconProps = {
  style?: React.CSSProperties;
};

export const ImageIcon = ({ style = {} }: IconProps) => {
  return (
    <img src="/assets/icons/image-icon.svg" alt="Frame" style={{ height: '2.4rem', ...style }} />
  );
};
